let loadingCount = 0;

export function setLoadingStatus(isLoading: boolean) {
  if (document.body) {
    isLoading ? loadingCount++ : loadingCount--;
    if (loadingCount) {
      document.body.classList.add('loading');
    } else {
      document.body.classList.remove('loading');
    }
  }
}
